import { Button, Form, Image, Input } from "antd";

const DeleteAccount = () => {
  return (
    <div className="min-h-screen flex justify-center items-center px-4 sm:px-0">
      <div className="w-full max-w-[550px] border border-[#f0f0f0] text-center p-6 rounded-lg">
        <h2 className="mt-3 mb-7 font-bold text-[22px]">Delete Account Request</h2>
        <Form
          layout="vertical"
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={{
            remember: false,
          }}
          autoComplete="off"
        >
          <Form.Item
            className="mt-3"
            label="Name"
            name="Name"
            rules={[
              {
                required: false,
                message: "Please enter your Name.",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            className="mt-3"
            label="Email"
            name="Email"
            rules={[
              {
                required: false,
                type: "number",
                message: "Please enter your Email.",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            className="mt-3"
            label="Reason"
            name="Reason"
            rules={[
              {
                required: false,
                type: "number",
                message: "Please enter your Reason.",
              },
            ]}
          >
            <Input.TextArea size="large" />
          </Form.Item>
          <div className="flex justify-end mt-6 gap-3">
            <Button>Submit</Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default DeleteAccount;
